<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center mb-20" style="border-bottom: solid 1px #E3F2FF;">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Ajouter un utilisateur</h3>
      </div>

      <div class="fit-content mb-20">
        <div class="p-20 bg-light-red radius-10 w-fit margin-center mb-10" style="border: solid 1px #F3C7C7;">
          <p class="no-margin red bold w-fit margin-center"><span class="exclamation-red">!</span>L'ajout d'un
            utilisateur a échoué.</p>
        </div>
        <p class="no-margin grey w-fit margin-center">
          Merci de contacter le support : <a href="mailto:support_client@v8te.com">support_client&#64;v8te.com</a>
        </p>
      </div>



      <div class="p-20">
        <p (click)=onDismiss(false) class="dark-blue pointer w-fit margin-center">Fermer</p>
      </div>
    </div>
  </div>
</div>